import React from 'react';
import { StowagePlanProvider, useStowagePlanStore } from './StowagePlanContext';
import { StowageUIProvider, useStowageUIStore } from './StowageUIContext';
import { StowageTankPlanProvider, useStowageTankPlanStore } from './StowageTankPlanContext';
import { StowageLayoutProvider, useStowageLayoutStore } from './StowageLayoutContext';
import { StowageSaveStatusProvider, useStowageSaveStatusStore } from './StowageSaveStatusContext';
import { ContextProps } from '../types/ContextProps';

export { useStowagePlanStore, useStowageUIStore, useStowageTankPlanStore, useStowageLayoutStore, useStowageSaveStatusStore };

export const StowageProvider = ({ children }: ContextProps) => (
    <StowagePlanProvider>
        <StowageUIProvider>
            <StowageTankPlanProvider>
                <StowageLayoutProvider>
                    <StowageSaveStatusProvider>{children}</StowageSaveStatusProvider>
                </StowageLayoutProvider>
            </StowageTankPlanProvider>
        </StowageUIProvider>
    </StowagePlanProvider>
);

/** @deprecated Use specific context hooks instead for better performance */
export const useStowageStore = () => ({
    ...useStowagePlanStore(),
    ...useStowageUIStore(),
    ...useStowageTankPlanStore(),
    ...useStowageLayoutStore(),
});
